import { Component, computed, signal, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MessengerService } from '../../services/messenger/messenger.service';
import { PortraitService } from '../../services/portraits/portrait.service';
import { PlayerPanel } from "../users/player-panel/player-panel";

@Component({
  selector: 'app-friendbar',
  imports: [FormsModule, PlayerPanel],
  templateUrl: './friendbar.html',
  styleUrl: './friendbar.scss',
})
export class Friendbar {
  private messenger = inject(MessengerService);
  private portraitService = inject(PortraitService);
  portraits = this.portraitService.portraits;

  currentUser = this.messenger.currentUser;
  searchTerm = signal('');
  newFriendName = signal('');

  friends = this.messenger.friends;
  onlineFriends = computed(() =>
    this.friends().filter(friend => friend.status !== 0)
  );
  filteredFriends = computed(() =>
    this.friends().filter(friend =>
      friend?.userName ? friend.userName.toLowerCase().includes(this.searchTerm().toLowerCase()) : true
    ).sort((a, b) => {
      if (a.status < b.status) return 1;
      if (a.status > b.status) return -1;
      return 0;
    })
  );

  getFriendPortrait = (id: any) => computed(() => {
    if (this.portraits().length > 0) {
      let portrait = this.portraits().filter(e => { return e.Id == id; })[0];
      if (portrait) {
        return portrait.fileName;
      }
      else
        return "bagfacepak/2.jpg";
    }
    else
      return "bagfacepak/2.jpg";
  });

  getStatusColor(status: any) {
    switch (status) {
      case 1: return 'text-success';
      case 2: return 'text-danger';
      case 3: return 'text-warning';
      default: return 'text-secondary';
    }
  }

  getStatusText(status: any) {
    switch (status) {
      case 1: return 'online';
      case 2: return 'away';
      case 3: return 'ingame';
      default: return 'offline';
    }
  }
}
